import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ListaComponent } from "./lista/lista.component";
import { ComponentesModule } from "src/app/componentes/componentes.module";
@NgModule({
    declarations: [
        //Componentes
        ListaComponent
    ],
    imports: [
        CommonModule,
        ComponentesModule
    ],
    providers: []
})

export class CategoriaModule { }